import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element.dataset.intlTelInputInitialized) return;

    if (window.initInternationalPhoneInput) {
      window.initInternationalPhoneInput(this.element);
      this.element.dataset.intlTelInputInitialized = "true";
    }
  }
}
